import { environment } from 'src/environments/environment';
import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';

@Component({
  selector: 'app-draft-starting',
  templateUrl: './draft-starting.component.html',
  styleUrls: ['./draft-starting.component.scss']
})
export class DraftStartingComponent implements OnInit {

  league: any = null;

  constructor(@Inject(MAT_DIALOG_DATA) private data, public dialogRef: MatDialogRef<DraftStartingComponent>) {
    this.league = data.league;
  }

  ngOnInit() {
  }

  formatTime(sec) {
    if (sec >= 60 * 60 * 24) {
      // days
      return Math.floor(sec / (60 * 60 * 24)) + " day";
    } else if (sec >= 60 * 60) {
      // hours
      return Math.floor(sec / (60 * 60)) + " hr";
    } else if (sec >= 60) {
      // minutes
      return Math.floor(sec / 60) + " min";
    } else {
      // seconds
      return sec + " sec";
    }
  }

  close() {
    this.dialogRef.close();
  }

  getURL() {
    return `${environment.SITE_URL}/drafts/${this.league.league_id}`;
  }

}
